module.exports = __webpack_public_path__ + "static/warp2-93750ad8c0a851056f0edfbf938ac0a1.png";